import { Component, OnInit, inject } from '@angular/core';
import { NavigationService } from '../../../../../../services/navigation.service';
import { HealthDataPageComponent } from '../../../../../../components/health-data-page/health-data-page.component';
import {
    HealthChartPeriod,
    HealthDataAggregateOperation,
    HealthDataType
} from "../../../../../../models/health.models";
import {dataType} from "terra-api/lib/esm/API/Data";

@Component({
    selector: 'app-sleep-in-bed-page',
    standalone: true,
    imports: [HealthDataPageComponent],
    templateUrl: './sleep-in-bed-page.component.html',
})
export default class SleepInBedPageComponent implements OnInit {
    #navigationService = inject(NavigationService);

    healthDataLabel = 'Sonno';
    chartLabel = 'Sonno';
    healthDataUnitSymbolLabel = 'ore';
    sleepInBedHealthDataType = HealthDataType.SLEEP_IN_BED;
    hasTwoDecimals = false;
    supportedPeriods: HealthChartPeriod[] = [HealthChartPeriod.week, HealthChartPeriod.month];
    payloadTypes: dataType[] = ['sleep'];
    HealthDataAggregateOperation = HealthDataAggregateOperation;

    ngOnInit(): void {
        this.#navigationService.saveCurrentRoute();
    }
}
